import React, { useEffect, useState } from "react";
import { Grid, Paper, Typography } from "@mui/material";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase"; // adjust path if needed
import { useAuth } from "../../contexts/AuthContext"; // assumes you have auth context

export default function DashboardSummary() {
  const { user } = useAuth(); // ✅ works if your AuthContext returns `user`
  const [connectedClientCount, setConnectedClientCount] = useState(null);

  useEffect(() => {
    async function fetchLinkedClients() {
      if (!user) return;
      const q = query(
        collection(db, "linkedClients"),
        where("accountantUid", "==", user?.uid)
      );
      const snapshot = await getDocs(q);
      setConnectedClientCount(snapshot.size);
    }

    fetchLinkedClients();
  }, [user]);

  const summaryItems = [
    {
      label: "Connected Clients",
      value: connectedClientCount !== null ? connectedClientCount : "–",
      color: "#3b82f6",
    },
    { label: "Receipts This Month", value: 120, color: "#16a34a" },
    { label: "Bank Accounts Linked", value: 2, color: "#8b5cf6" },
    { label: "Pending VAT Returns", value: 1, color: "#f59e0b" },
  ];

  return (
    <Grid container spacing={2} mb={3}>
      {summaryItems.map((item) => (
        <Grid size={{ xs: 12, sm: 6, md: 3 }} key={item.label}>
          <Paper
            elevation={1}
            sx={{
              p: 2,
              borderLeft: `5px solid ${item.color}`,
              backgroundColor: "#fff",
              transition: "transform 0.2s",
              "&:hover": { transform: "translateY(-2px)", boxShadow: 3 },
            }}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              color="text.primary"
              gutterBottom
            >
              {item.value}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {item.label}
            </Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}
